import script from "./DepositContractTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositContractTemplate.vue?vue&type=script&setup=true&lang=js"

import "./DepositContractTemplate.vue?vue&type=style&index=0&id=24e0cc94&scoped=true&lang=css"
import "./DepositContractTemplate.vue?vue&type=style&index=1&id=24e0cc94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e0cc94"]])

export default __exports__